function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigation, useRoute } from "@react-navigation/native";
import { Image } from "expo-image";
import { Component, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Animated, Easing, Platform } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import { useReanimatedKeyboardAnimation } from "react-native-keyboard-controller";
import RNAnimated, { Easing as RNEasing, SlideInDown, SlideOutDown } from "react-native-reanimated";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Actor, Kind } from "@oui/lib/src/types";
import NotConnected from "../assets/notconnected.svg";
import { Button } from "../components/Button";
import { Chat } from "../components/Chat";
import { ChatInput } from "../components/ChatInput";
import { useConversationContext } from "../components/ConversationContext";
import { SessionTabs } from "../components/Session/Tabs/Tabs";
import { VideosActivities } from "../components/Session/Tabs/VideosActivities";
import { Text } from "../components/Text";
import { View } from "../components/View";
import { manifest } from "../constants";
import { ChatSideEffectContext } from "../hooks/useChatSideEffect";
import { ClientStatus, useConversation } from "../hooks/useConversation";
import { useProgressByContent, useProgressFetcher } from "../hooks/useCurrentUser";
import { useI18n } from "../lib/i18n";
import { logEvent } from "../lib/log";
import Sentry from "../sentry";
import { Shadow, useTheme } from "../styles";
function ConversationInner(props) {
    var _route_params, _route_params1, _messages_chat_, _lastChatEnvelope_props_text_;
    var navigation = useNavigation();
    var route = useRoute();
    var _useTheme = useTheme(), scheme = _useTheme.scheme, theme = _useTheme.theme;
    var safeAreaInsets = useSafeAreaInsets();
    var _useReanimatedKeyboardAnimation = useReanimatedKeyboardAnimation(), keyboardTranslateY = _useReanimatedKeyboardAnimation.height;
    var translateY = useRef(new Animated.Value(0));
    var _useState = _sliced_to_array(useState(0), 2), inputHeight = _useState[0], setInputHeight = _useState[1];
    var fetchProgress = useProgressFetcher();
    var convoID = (_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.ID;
    var completed = ((_route_params1 = route.params) === null || _route_params1 === void 0 ? void 0 : _route_params1.completed) === 'true';
    useEffect(function() {
        logEvent('view_session', {
            session: convoID
        });
    }, [
        convoID
    ]);
    var handleSideEffect = function(effect) {
        if (effect.kind === 'navigate') {
            if (effect.routeName === 'home') {
                if (!props._cmsEmbed) {
                    fetchProgress().then(function() {
                        navigation.goBack();
                    }).catch(function(e) {
                        Sentry.captureException(e);
                        navigation.goBack();
                    });
                }
            } else {
                // @ts-expect-error we don't have precise enough types for routeName/params so we just have to trust
                // the SideEffect
                navigation.navigate(effect.routeName, effect.params);
            }
        }
    };
    var _useConversation = useConversation(convoID, completed, handleSideEffect), checkNetworkStatus = _useConversation.checkNetworkStatus, status = _useConversation.status, messages = _useConversation.messages, send = _useConversation.send;
    var _useState1 = _sliced_to_array(useState(false), 2), ignoreNetworkError = _useState1[0], setIgnoreNetworkError = _useState1[1];
    useLayoutEffect(function() {
        setIgnoreNetworkError(false);
    }, [
        status
    ]);
    var handleInput = function(payload) {
        send(_object_spread_props(_object_spread({}, payload), {
            t: Date.now()
        }));
    };
    var hasEnvelopes = !!(messages.input.length || messages.chat.length);
    function onInputChangeHeight(height) {
        setInputHeight(height);
        Animated.timing(translateY.current, {
            easing: Easing.inOut(Easing.ease),
            useNativeDriver: true,
            toValue: -height,
            duration: 200
        }).start();
    }
    var lastChatEnvelope = messages.chat[messages.chat.length - 1];
    return /*#__PURE__*/ _jsxs(RNAnimated.View, {
        style: {
            flex: 1,
            backgroundColor: scheme === 'dark' ? 'white' : theme.color.gray800,
            paddingBottom: safeAreaInsets.bottom,
            transform: [
                {
                    translateY: keyboardTranslateY
                }
            ]
        },
        testID: "Conversation",
        children: [
            /*#__PURE__*/ _jsx(ChatSideEffectContext.Provider, {
                value: handleSideEffect,
                children: /*#__PURE__*/ _jsxs(View, {
                    flex: 1,
                    children: [
                        /*#__PURE__*/ _jsx(Animated.View, {
                            style: [
                                {
                                    flex: 1,
                                    zIndex: 1,
                                    transform: [
                                        {
                                            translateY: translateY.current
                                        }
                                    ]
                                },
                                Platform.OS === 'ios' ? // (above) than the screen header.
                                // This results in VoiceOver ordering elements in the following manner:
                                // * Last chat message
                                // * Screen header elements
                                // * ChatInput
                                // rather than the order we actually want. By applying a marginTop, we "fix" the order
                                {
                                    marginTop: inputHeight
                                } : null
                            ],
                            children: /*#__PURE__*/ _jsx(Chat, {
                                messages: messages.chat,
                                hasEnvelopes: hasEnvelopes
                            })
                        }),
                        hasEnvelopes ? /*#__PURE__*/ _jsx(Animated.View, {
                            style: {
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                zIndex: 3,
                                transform: [
                                    {
                                        translateY: translateY.current.interpolate({
                                            inputRange: [
                                                -inputHeight,
                                                0
                                            ],
                                            outputRange: [
                                                0,
                                                inputHeight
                                            ],
                                            extrapolate: 'clamp'
                                        })
                                    }
                                ]
                            },
                            children: /*#__PURE__*/ _jsx(ChatInput, {
                                onInputChangeHeight: onInputChangeHeight,
                                onInput: handleInput,
                                curr: messages.input[messages.input.length - 1],
                                lastTextWasUser: ((_messages_chat_ = messages.chat[messages.chat.length - 1]) === null || _messages_chat_ === void 0 ? void 0 : _messages_chat_.from) === Actor.User,
                                lastTextContent: (lastChatEnvelope === null || lastChatEnvelope === void 0 ? void 0 : lastChatEnvelope.kind) === Kind.ChatText ? (_lastChatEnvelope_props_text_ = lastChatEnvelope.props.text[0]) === null || _lastChatEnvelope_props_text_ === void 0 ? void 0 : _lastChatEnvelope_props_text_.replace(/\*/g, '') : undefined
                            })
                        }) : null
                    ]
                })
            }),
            ignoreNetworkError || [
                ClientStatus.CONNECTED || ClientStatus.UNKNOWN
            ].includes(status) ? null : /*#__PURE__*/ _jsx(RNAnimated.View, {
                pointerEvents: "box-none",
                style: {
                    bottom: 0,
                    height: 400,
                    left: 0,
                    position: 'absolute',
                    right: 0,
                    zIndex: 3,
                    elevation: 10
                },
                entering: SlideInDown.duration(400).easing(RNEasing.in(RNEasing.ease)),
                exiting: SlideOutDown.duration(400).easing(RNEasing.in(RNEasing.ease)),
                children: /*#__PURE__*/ _jsxs(View, {
                    testID: "Conversation_networkIssue",
                    style: [
                        Shadow.high,
                        {
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderTopStartRadius: 20,
                            borderTopEndRadius: 20,
                            backgroundColor: 'white',
                            alignItems: 'center',
                            padding: 25,
                            paddingHorizontal: 45
                        }
                    ],
                    spacing: 8,
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            source: NotConnected,
                            style: {
                                width: 48,
                                height: 48
                            }
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: "You're offline",
                            weight: "bold",
                            size: 21
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: "".concat(manifest.name, " is having trouble connecting. Check your wifi or data connection."),
                            textAlign: "center"
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            row: true,
                            spacing: 24,
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "text",
                                    text: "Dismiss",
                                    onPress: function() {
                                        setIgnoreNetworkError(true);
                                    },
                                    style: {
                                        marginVertical: 25
                                    },
                                    testID: "Converation_networkIssueDismissButton"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    text: "Retry",
                                    onPress: function() {
                                        Sentry.captureMessage('retry network connection');
                                        return checkNetworkStatus();
                                    },
                                    style: {
                                        marginVertical: 25
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var ConversationDisplayMode = function(props) {
    var _progress_route_params_ID;
    var _useProgressByContent = useProgressByContent(), progress = _useProgressByContent.data;
    var $t = useI18n().$t;
    var navigation = useNavigation();
    var route = useRoute();
    var _useConversationContext = useConversationContext(), showTabsAfterCompletion = _useConversationContext.showTabsAfterCompletion, showTabsBeforeCompletion = _useConversationContext.showTabsBeforeCompletion;
    var showTabs = showTabsBeforeCompletion || showTabsAfterCompletion && ((_progress_route_params_ID = progress[route.params.ID]) === null || _progress_route_params_ID === void 0 ? void 0 : _progress_route_params_ID.completed);
    useEffect(function() {
        if (showTabs) {
            navigation.setOptions({
                headerStyle: {
                    shadowColor: 'transparent'
                }
            });
        }
    }, [
        showTabs,
        navigation
    ]);
    if (showTabs) {
        var chatTab = {
            value: 'chat',
            text: $t({
                id: 'Conversation_chatTabText',
                defaultMessage: 'Chat'
            }),
            icon: 'chat-double',
            Component: /*#__PURE__*/ _jsx(ConversationInner, _object_spread({}, props))
        };
        var videoTab = {
            value: 'video',
            text: $t({
                id: 'Conversation_videoTabText',
                defaultMessage: 'Videos & activities'
            }),
            icon: 'video',
            Component: /*#__PURE__*/ _jsx(VideosActivities, {
                contentType: route.params.ID,
                onComplete: navigation.goBack,
                testID: "Conversation_videosAndActivitiesScrollView"
            })
        };
        return /*#__PURE__*/ _jsx(SessionTabs, {
            defaultTab: "chat",
            sessionTabs: [
                chatTab,
                videoTab
            ]
        });
    }
    return /*#__PURE__*/ _jsx(ConversationInner, _object_spread({}, props));
};
/**
 * Screen that manages interaction with the chatbot. Displays chat messages and
 * inputs to interact with content.
 *
 * **Session UI**
 *
 * Each session has a header with:
 *
 * - Back arrow \
 *   (to “opt out” and go back to the screen the user was previously on)
 * - Title of session
 * - “Quick access” icon - configurable by the consuming app to make navigation
 * to important resources easy, if applicable
 *
 * **First time doing a session**
 *
 * The first time the user goes through the session chat conversation, the
 * non-AI chatbot presents information via text bubbles similar to text
 * messages. User responses are also presented as text bubbles similar to text
 * messages.
 *
 * *User responses*
 *
 * The user responses are often offered button choices. Each button choice can
 * lead to a slightly different chat path.
 *
 * Response types:
 *
 * - Button choice
 * - Radio choice
 * - Checkbox choices
 * - Slider input
 * - Text input
 *
 *
 *
 * **Going back to a completed session**
 *
 * The entire conversation is there for the user to review again. There are also
 * two tabs now at the top.
 *
 * *Two tabs*\
 * There are tabs for the chat conversation and Videos & Activities. This is so
 * the videos and activity widgets are easier to access/find.
 *
 * Tabs appear AFTER the chat session is complete
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-149}
 */ export var Conversation = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Conversation, Component);
    function Conversation() {
        _class_call_check(this, Conversation);
        var _this;
        _this = _call_super(this, Conversation, arguments), _define_property(_this, "state", {
            hasError: false
        });
        return _this;
    }
    _create_class(Conversation, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                var _this = this;
                Sentry.withScope(function(scope) {
                    var _this_props_route_params, _this_props_route;
                    scope.setExtra('ConversationID', (_this_props_route = _this.props.route) === null || _this_props_route === void 0 ? void 0 : (_this_props_route_params = _this_props_route.params) === null || _this_props_route_params === void 0 ? void 0 : _this_props_route_params.ID);
                    Sentry.captureException(error);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    return /*#__PURE__*/ _jsx(View, {
                        style: {
                            padding: 20
                        },
                        children: /*#__PURE__*/ _jsx(Text, {
                            text: "Something went wrong"
                        })
                    });
                }
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(SystemBars, {
                            style: "dark"
                        }),
                        /*#__PURE__*/ _jsx(ConversationDisplayMode, _object_spread({}, this.props))
                    ]
                });
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return Conversation;
}(Component);
